import styled from 'styled-components';

export const PageFormContainer = styled.section`
  height: calc(100vh - 3.5rem);
  width: 100vw;
  background-color: ${({ theme }) => theme.milkGrey};
  overflow: auto;
`;
